import { loading, error, success } from 'State/actions';
import * as types from './types';
import {
  toastErrorFromCatch,
  createToast,
  toastType,
} from 'Common/ToastHelper';
import { getApplicationList } from '../grid/actions';

export const fetchStudents = (
  pageNumber = 1,
  filters = [],
  sortColumns = [],
  showWithdrawn = false
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCHING, true)
    );

    try {
      const model = {
        PageNumber: pageNumber,
        ShowWithDrawn: showWithdrawn,
        PageSize: 10,
        SiteId: 'ALL',
        Filter: [
          ...filters.map(filter => ({
            FilterName: filter.id,
            FilterValue: filter.value,
          })),
          { FilterName: 'AppStatuses', FilterValue: true },
        ],
        SortColumn: sortColumns.map(sortColumn => ({
          SortName: sortColumn.id,
          SortDirection: sortColumn.desc ? 'desc' : 'asc',
        })),
      };

      const response = await MPWWebApi.postGenericInsertUpdate(
        'Student/ApplicationStudents',
        model
      );

      dispatch(
        success(
          types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_SET_STUDENTS,
          response.data
        )
      );
    } catch (ex) {
      dispatch(
        error(types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCH_ERROR, ex)
      );
    }

    dispatch(
      loading(types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCHING, false)
    );
  };
};

export const replaceMember = (memberId, student) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCHING, true)
    );

    try {
      const model = {
        MemberId: memberId,
        Student: student,
      };

      const response = await MPWWebApi.postGenericInsertUpdate(
        `IncomingApplication/ReplaceIncomingAppMember/`,
        model
      );

      if (response.status === 200) {
        dispatch(getApplicationList());
        createToast(toastType.success, 'Success', `Member updated.`);
      } else {
        createToast(
          toastType.error,
          'Error',
          'An error occured while updating this member.'
        );
      }
    } catch (ex) {
      dispatch(
        error(types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCH_ERROR, ex)
      );
      toastErrorFromCatch(ex, 'An error occured while updating this member.');
    }
    dispatch(
      loading(types.REVIEW_INCOMING_APPLICATIONS_STUDENT_LOOKUP_FETCHING, false)
    );
  };
};



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/studentlookup/actions.js